import { Injectable } from '@angular/core'
import { Action, Store, select } from '@ngrx/store'
import { GbBaseFacade } from 'libs/shared/data-access-core/src/lib/+state/gb-base-facade-interface'
import * as ProfileItemActivitiesSelectors from './profile-item-activities.selectors'

@Injectable({
  providedIn: 'root',
})
export class ProfileItemActivitiesFacade implements GbBaseFacade {
  loaded$ = this.store.pipe(select(ProfileItemActivitiesSelectors.getProfileItemActivitiesLoaded))
  allActivities$ = this.store.select(ProfileItemActivitiesSelectors.getAllProfileItemActivities)
  purchasedRaffleTicketsByProfile$ = this.store.select(
    ProfileItemActivitiesSelectors.getPurchasedRaffleTicketsByProfile,
  )
  pendingRaffleTicketsByProfile$ = this.store.select(ProfileItemActivitiesSelectors.getPendingRaffleTicketsByProfile)
  remainingRaffleTicketsByProfile$ = this.store.select(
    ProfileItemActivitiesSelectors.getRemainingRaffleTicketsByProfile,
  )
  purchasedUnitsByProfile$ = this.store.select(ProfileItemActivitiesSelectors.getPurchasedUnitsByProfile)
  pendingUnitsByProfile$ = this.store.select(ProfileItemActivitiesSelectors.getPendingUnitsByProfile)
  remainingPurchaseUnitsByProfile$ = this.store.select(
    ProfileItemActivitiesSelectors.getRemainingPurchaseUnitsByProfile,
  )

  constructor(private store: Store) {}

  dispatch(action: Action) {
    return this.store.dispatch(action)
  }
}
